import { Skeleton } from '@vizit/atoms';
import * as React from 'react';
import { Table, TableBody } from 'react-aria-components';
import { OrganizationRow } from '../organization-row';
import { organizationTableWrapperClasses, tableClasses, tableContainerClasses } from './organization-table.classes';
import { OrganizationTableHeader } from './organization-table.header';

const ROW_HEIGHT = 120; // Approximate height of each row (py-8 = 64px + content)
const HEADER_HEIGHT = 200; // Approximate height for header and other elements

/**
 * Loading skeleton component for the organization table
 */
function OrganizationTableSkeleton() {
  const [skeletonRows, setSkeletonRows] = React.useState(5);

  React.useEffect(() => {
    const calculateRows = () => {
      const viewportHeight = window.innerHeight;
      const availableHeight = viewportHeight - HEADER_HEIGHT;
      const calculatedRows = Math.max(3, Math.floor(availableHeight / ROW_HEIGHT));
      setSkeletonRows(calculatedRows);
    };

    calculateRows();
    window.addEventListener('resize', calculateRows);
    return () => window.removeEventListener('resize', calculateRows);
  }, []);

  return (
    <div className={organizationTableWrapperClasses()}>
      <Skeleton className="h-6 w-32" variant="square" />
      <div className={tableContainerClasses()}>
        <Table className={tableClasses()} aria-label="Loading organization table">
          <OrganizationTableHeader />
          <TableBody>
            {Array.from({ length: skeletonRows }, (_, index) => (
              <OrganizationRow
                // biome-ignore lint/suspicious/noArrayIndexKey: Static skeleton rows don't reorder and have no stable IDs
                key={`skeleton-row-${index}`}
                organizationId={`skeleton-row-${index}`}
                name=""
                accountType=""
                productCategories={[]}
                icpProductCategories={{}}
                createdBy=""
                isLoading={true}
              />
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}

export { OrganizationTableSkeleton };
